/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type Address = {
  __typename?: 'Address';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type Branch = {
  __typename?: 'Branch';
  businessManager?: Maybe<Scalars['String']['output']>;
  company: Scalars['String']['output'];
  contract: Scalars['String']['output'];
  country: Scalars['String']['output'];
  description: Scalars['String']['output'];
  divisionManager?: Maybe<Scalars['String']['output']>;
  salesManager?: Maybe<Scalars['String']['output']>;
  sequenceNo: Scalars['Int']['output'];
  timestamp: Scalars['String']['output'];
  users: Array<BranchUser>;
};

export type BranchUser = {
  __typename?: 'BranchUser';
  email: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type ChargeLines = {
  __typename?: 'ChargeLines';
  chargeType?: Maybe<Scalars['String']['output']>;
  chargedQty?: Maybe<Scalars['Float']['output']>;
  lineNo?: Maybe<Scalars['Float']['output']>;
  netAmount?: Maybe<Scalars['Float']['output']>;
};

export type CompletedShipment = {
  __typename?: 'CompletedShipment';
  shipmentId: Scalars['Int']['output'];
  timestamp: Scalars['String']['output'];
};

export type Consolidation = {
  __typename?: 'Consolidation';
  agent: Scalars['String']['output'];
  arrived: Scalars['String']['output'];
  completed: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  driveTo: Scalars['String']['output'];
  id: Scalars['String']['output'];
  loadingStarted: Scalars['String']['output'];
  orderNo: Scalars['String']['output'];
  plannedArrivalTime: Scalars['String']['output'];
  plannedDeliveryDate: Scalars['String']['output'];
  plannedShipDate: Scalars['String']['output'];
  shipmentId: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type ConsolidationEvent = {
  __typename?: 'ConsolidationEvent';
  createdAt: Scalars['String']['output'];
  data: Consolidation;
  key: Scalars['String']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  contactType?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type Customer = {
  __typename?: 'Customer';
  address?: Maybe<Array<CustomerAddress>>;
  associationNo: Scalars['String']['output'];
  branchId?: Maybe<Scalars['String']['output']>;
  creditInfo?: Maybe<Array<CustomerCreditInfo>>;
  custGrp?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['String']['output'];
  customerIdPay?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  representatives?: Maybe<Array<Representative>>;
  sequenceNo: Scalars['Int']['output'];
  timestamp: Scalars['String']['output'];
};

export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  address_id: Scalars['String']['output'];
  address_type: Scalars['String']['output'];
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  ean_location?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

export type CustomerContactSetting = {
  __typename?: 'CustomerContactSetting';
  setting: Scalars['Int']['output'];
};

export type CustomerCreditInfo = {
  __typename?: 'CustomerCreditInfo';
  company: Scalars['String']['output'];
  creditBlock: Scalars['Boolean']['output'];
  creditLimit?: Maybe<Scalars['Int']['output']>;
  creditRating?: Maybe<Scalars['String']['output']>;
  creditRatingScore?: Maybe<Scalars['Int']['output']>;
  lastUpdate?: Maybe<Scalars['String']['output']>;
};

export type CustomerOrderTracker = {
  __typename?: 'CustomerOrderTracker';
  customerId: Scalars['String']['output'];
  trackers: Array<OrderTracker>;
};

export type CustomerRelation = {
  __typename?: 'CustomerRelation';
  branchId?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type Delivery = {
  __typename?: 'Delivery';
  company: Scalars['String']['output'];
  deliveredDateTime?: Maybe<Scalars['String']['output']>;
  enRouteDatetime?: Maybe<Scalars['String']['output']>;
  plannedDatetime?: Maybe<Scalars['String']['output']>;
  registeredDatetime: Scalars['String']['output'];
  routeId: Scalars['String']['output'];
};

/** Satisfaction score for a related shipment */
export type Feedback = {
  __typename?: 'Feedback';
  meta?: Maybe<FeedbackMeta>;
  score: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type FeedbackEvent = {
  __typename?: 'FeedbackEvent';
  createdAt: Scalars['String']['output'];
  data: Feedback;
  key: Scalars['String']['output'];
};

export type FeedbackMeta = {
  __typename?: 'FeedbackMeta';
  ref?: Maybe<Scalars['String']['output']>;
};

export type FulfilledShipment = {
  __typename?: 'FulfilledShipment';
  shipmentId: Scalars['Int']['output'];
  timestamp: Scalars['String']['output'];
};

export type LastUpdate = {
  __typename?: 'LastUpdate';
  completedShipments: Array<CompletedShipment>;
  feedbacks: Array<Feedback>;
  fulfilledShipments: Array<FulfilledShipment>;
  order?: Maybe<Order>;
  registered: Scalars['String']['output'];
  shipments: Array<Shipment>;
  trips: Array<Consolidation>;
};

export type Line = {
  __typename?: 'Line';
  article: Scalars['String']['output'];
  datasheet: Scalars['String']['output'];
  delivered: Scalars['String']['output'];
  inventoryPart?: Maybe<Scalars['Boolean']['output']>;
  ordered: Scalars['String']['output'];
  safetysheet: Scalars['String']['output'];
};

/** The location where a custoemr should either pickup or receive order items */
export type Location = {
  __typename?: 'Location';
  /** Primary address */
  address1: Scalars['String']['output'];
  /** Secondary address */
  address2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  /** Company Name */
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

/** Expose internal service log that might simplify debugging or making sure that customer-flows work properly */
export type Log = {
  __typename?: 'Log';
  createdAt: Scalars['String']['output'];
  /** The service which produced the log entry */
  source: Scalars['String']['output'];
  /** The acual log message */
  text: Scalars['String']['output'];
  /** Log variant, may be used to filter or display specific logs */
  type: Scalars['String']['output'];
};

export type LogEvent = {
  __typename?: 'LogEvent';
  createdAt: Scalars['String']['output'];
  data: Log;
  key: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Set contact settings for a given customer id, pass a valid tracker along to "verify" identity */
  setCustomerContactSetting: CustomerContactSetting;
  setFeedback?: Maybe<Feedback>;
};


export type MutationSetCustomerContactSettingArgs = {
  customerId: Scalars['String']['input'];
  setting: Scalars['Int']['input'];
};


export type MutationSetFeedbackArgs = {
  orderNo: Scalars['String']['input'];
  ref?: InputMaybe<Scalars['String']['input']>;
  score: Scalars['Int']['input'];
  text: Scalars['String']['input'];
};

export type Notification = ConsolidationEvent | FeedbackEvent | LogEvent | OrderEvent | ShipmentEvent;

/** The order state, at the specific point-in-time */
export type Order = {
  __typename?: 'Order';
  billAddress?: Maybe<Address>;
  cObjectNo?: Maybe<Scalars['String']['output']>;
  cfCMarking?: Maybe<Scalars['String']['output']>;
  chargeLines?: Maybe<Array<Maybe<ChargeLines>>>;
  company: Scalars['String']['output'];
  contacts?: Maybe<Array<Maybe<Contact>>>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  customerPoNo?: Maybe<Scalars['String']['output']>;
  deliveryAddress: Address;
  deliveryTerms: Scalars['String']['output'];
  deliveryTerms_desc: Scalars['String']['output'];
  digitalDeliveryInfo: Scalars['Boolean']['output'];
  event?: Maybe<Scalars['String']['output']>;
  marking?: Maybe<Scalars['String']['output']>;
  orderCoordinator?: Maybe<Scalars['String']['output']>;
  orderCoordinatorName?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  orderLines?: Maybe<Array<Maybe<OrderLine>>>;
  orderNo: Scalars['String']['output'];
  regionCode?: Maybe<Scalars['String']['output']>;
  sendAutoOc: Scalars['String']['output'];
  sequenceNo: Scalars['Int']['output'];
  shipViaCode: Scalars['String']['output'];
  shipViaCodeDesc: Scalars['String']['output'];
  site: Scalars['String']['output'];
  siteAddress?: Maybe<Address>;
  state?: Maybe<Scalars['String']['output']>;
  tb3Cost?: Maybe<Scalars['Float']['output']>;
  tb3Price?: Maybe<Scalars['Float']['output']>;
  tb3Revenue?: Maybe<Scalars['Float']['output']>;
  timestamp: Scalars['String']['output'];
  totalGrossAmount?: Maybe<Scalars['Float']['output']>;
  totalNetAmount?: Maybe<Scalars['Float']['output']>;
  wantedDeliveryDate?: Maybe<Scalars['String']['output']>;
};

/** Event state triggered by a customer-order-status update (produced by the ERP) */
export type OrderEvent = {
  __typename?: 'OrderEvent';
  createdAt: Scalars['String']['output'];
  data: Order;
  key: Scalars['String']['output'];
};

export type OrderLine = {
  __typename?: 'OrderLine';
  buyerPartNo?: Maybe<Scalars['String']['output']>;
  dataSheet?: Maybe<Scalars['String']['output']>;
  demandCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  gtin?: Maybe<Scalars['String']['output']>;
  inputQty?: Maybe<Scalars['Float']['output']>;
  inputUom?: Maybe<Scalars['String']['output']>;
  inventoryPart?: Maybe<Scalars['Boolean']['output']>;
  lineItem_no?: Maybe<Scalars['String']['output']>;
  lineNo?: Maybe<Scalars['String']['output']>;
  netAmount?: Maybe<Scalars['Float']['output']>;
  plannedDeliveryDate?: Maybe<Scalars['String']['output']>;
  priceConvFactor?: Maybe<Scalars['Float']['output']>;
  priceUom?: Maybe<Scalars['String']['output']>;
  qtyDelivered?: Maybe<Scalars['Float']['output']>;
  qtyOrdered?: Maybe<Scalars['String']['output']>;
  relNo?: Maybe<Scalars['String']['output']>;
  safetySheet?: Maybe<Scalars['String']['output']>;
  salesUom?: Maybe<Scalars['String']['output']>;
  shipViaCode?: Maybe<Scalars['String']['output']>;
  sourceOrderNo?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  supplyCode?: Maybe<Scalars['String']['output']>;
  supplySite?: Maybe<Scalars['String']['output']>;
  totNetAmount?: Maybe<Scalars['Float']['output']>;
  vendorNo?: Maybe<Scalars['String']['output']>;
  vendorPartNo?: Maybe<Scalars['String']['output']>;
  wantedDeliveryDate?: Maybe<Scalars['String']['output']>;
};

export type OrderSummaries = {
  __typename?: 'OrderSummaries';
  nextKey?: Maybe<Scalars['String']['output']>;
  summaries: Array<OrderSummary>;
};

export type OrderSummary = {
  __typename?: 'OrderSummary';
  compositeStatus: Scalars['String']['output'];
  feedback?: Maybe<Feedback>;
  feedbacks: Array<Feedback>;
  order?: Maybe<Order>;
  orderNo: Scalars['String']['output'];
  registered: Scalars['String']['output'];
  shipments: Array<Shipment>;
  trips: Array<Consolidation>;
};

/**
 * The tracker keeps track of a given order, what type of events the system recevie from the ERP, it's
 * state, logs, and other things that simplifies and improve customer service tasks.
 */
export type OrderTracker = {
  __typename?: 'OrderTracker';
  /** registered|enroute|delivered|cancelled|blocked|partiallydelivered */
  compositeStatus: Scalars['String']['output'];
  lastUpdates: LastUpdate;
  logs: Array<Log>;
  /** Unique order identifier */
  orderNo: Scalars['ID']['output'];
  /** Timestamp from the first order event that was received */
  registered: Scalars['String']['output'];
};

export type Pickup = {
  __typename?: 'Pickup';
  /** @deprecated Field no longer supported */
  address?: Maybe<Scalars['String']['output']>;
  address1?: Maybe<PickupAddress>;
  deliveredDateTime?: Maybe<Scalars['String']['output']>;
  fulfilledDateTime?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  registeredDatetime: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type PickupAddress = {
  __typename?: 'PickupAddress';
  city: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Read all orders from a given customer */
  getAllOrderTrackers: Array<OrderTracker>;
  /** Retrieve all customers for a given Branch */
  getBranchCustomers: Array<Customer>;
  /** Retrieve the matching customer */
  getCustomer?: Maybe<Customer>;
  /** Read contact settings for a given customer id */
  getCustomerContactSetting?: Maybe<CustomerContactSetting>;
  /** Read all orders summaries from a list of given customers */
  getOrderSummariesByCustomer: OrderSummaries;
  /** Retrevie a tracker for a given order, by using it's orderNo. */
  getOrderSummary?: Maybe<OrderSummary>;
  /**
   * Retrevie a tracker for a given order, by using it's orderNo.
   * @deprecated Use getOrderSummary
   */
  getOrderTracker?: Maybe<OrderTracker>;
  /**
   * Read all order trackers from a list of given customers
   * @deprecated Use getOrderSummariesByCustomers
   */
  getOrderTrackersByCustomers: Array<CustomerOrderTracker>;
  getShipmentSummary?: Maybe<ShipmentSummary>;
  getShipmentSummaryFromHash?: Maybe<ShipmentSummary>;
  /** Retrieve all user customer relations */
  getUserCustomerRelations: UserCustomerRelation;
};


export type QueryGetAllOrderTrackersArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryGetBranchCustomersArgs = {
  branchId: Scalars['String']['input'];
};


export type QueryGetCustomerArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryGetCustomerContactSettingArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryGetOrderSummariesByCustomerArgs = {
  customerId: Scalars['String']['input'];
  nextKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOrderSummaryArgs = {
  orderNo: Scalars['String']['input'];
};


export type QueryGetOrderTrackerArgs = {
  orderNo: Scalars['String']['input'];
};


export type QueryGetOrderTrackersByCustomersArgs = {
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetShipmentSummaryArgs = {
  orderNo: Scalars['String']['input'];
};


export type QueryGetShipmentSummaryFromHashArgs = {
  hash: Scalars['String']['input'];
};


export type QueryGetUserCustomerRelationsArgs = {
  email: Scalars['String']['input'];
};

export type Representative = {
  __typename?: 'Representative';
  email: Scalars['String']['output'];
  type: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type Shipment = {
  __typename?: 'Shipment';
  shipmentHead: ShipmentHead;
  shipmentLines: Array<ShipmentLine>;
};

export type ShipmentEvent = {
  __typename?: 'ShipmentEvent';
  createdAt: Scalars['String']['output'];
  /**
   * The "global" shipment information for the given event this includes e.g the shipment ID
   * for the all shipment lines.
   */
  data: Shipment;
  key: Scalars['String']['output'];
};

/** Contains informatin about a given shipment */
export type ShipmentHead = {
  __typename?: 'ShipmentHead';
  pickupLocation?: Maybe<Location>;
  receiverId: Scalars['String']['output'];
  routeId: Scalars['String']['output'];
  shipVia: Scalars['String']['output'];
  shipmentId: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type ShipmentInfo = {
  __typename?: 'ShipmentInfo';
  delivery?: Maybe<Delivery>;
  feedback?: Maybe<Feedback>;
  id: Scalars['String']['output'];
  images: Array<Maybe<Scalars['String']['output']>>;
  lines: Array<Line>;
  pickup?: Maybe<Pickup>;
  plannedDeliveryDate?: Maybe<Scalars['String']['output']>;
  shipViaCode: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

/** Detailed shipment line information for a up-stream order line */
export type ShipmentLine = {
  __typename?: 'ShipmentLine';
  connectedSourceQty?: Maybe<Scalars['Float']['output']>;
  orderSource?: Maybe<SourceOrder>;
  qtyPicked?: Maybe<Scalars['Float']['output']>;
  qtyShipped?: Maybe<Scalars['Float']['output']>;
  shipmentId?: Maybe<Scalars['String']['output']>;
  shipmentLineNo?: Maybe<Scalars['Int']['output']>;
  shipmentSourceLineItemNo?: Maybe<Scalars['String']['output']>;
  shipmentSourceLineNo?: Maybe<Scalars['String']['output']>;
  shipmentSourceOrderNo?: Maybe<Scalars['String']['output']>;
  shipmentSourceRelNo?: Maybe<Scalars['String']['output']>;
  sourcePartNo?: Maybe<Scalars['String']['output']>;
};

export type ShipmentSummary = {
  __typename?: 'ShipmentSummary';
  cObjectNo?: Maybe<Scalars['String']['output']>;
  cfCMarking?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['String']['output'];
  customerPoNo?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  marking: Scalars['String']['output'];
  orderNo: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  registered: Scalars['String']['output'];
  shipments: Array<ShipmentInfo>;
  unPlannedLines: Array<Line>;
};

/** Upstream order information (Order) */
export type SourceOrder = {
  __typename?: 'SourceOrder';
  lineItemNo?: Maybe<Scalars['Int']['output']>;
  lineNo?: Maybe<Scalars['Int']['output']>;
  orderno?: Maybe<Scalars['String']['output']>;
  qtyOnOrder?: Maybe<Scalars['Float']['output']>;
  relNo?: Maybe<Scalars['String']['output']>;
};

export type UserCustomerRelation = {
  __typename?: 'UserCustomerRelation';
  customers: Array<CustomerRelation>;
  email: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
};

export type GetCustomerContactSettingQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type GetCustomerContactSettingQuery = { __typename?: 'Query', getCustomerContactSetting?: { __typename?: 'CustomerContactSetting', setting: number } | null };

export type GetTrackerQueryVariables = Exact<{
  orderNo: Scalars['String']['input'];
}>;


export type GetTrackerQuery = { __typename?: 'Query', getOrderTracker?: { __typename?: 'OrderTracker', orderNo: string, lastUpdates: { __typename?: 'LastUpdate', order?: { __typename?: 'Order', state?: string | null, orderNo: string, company: string, marking?: string | null, cfCMarking?: string | null, orderLines?: Array<{ __typename?: 'OrderLine', lineNo?: string | null, relNo?: string | null, description?: string | null, salesUom?: string | null } | null> | null, contacts?: Array<{ __typename?: 'Contact', name?: string | null, phone?: string | null, firstName?: string | null, lastName?: string | null, contactType?: string | null } | null> | null } | null, shipments: Array<{ __typename?: 'Shipment', shipmentHead: { __typename?: 'ShipmentHead', shipVia: string, shipmentId: number, pickupLocation?: { __typename?: 'Location', name: string, city: string, zipCode: string, address1: string } | null }, shipmentLines: Array<{ __typename?: 'ShipmentLine', qtyPicked?: number | null, orderSource?: { __typename?: 'SourceOrder', relNo?: string | null, lineNo?: number | null, qtyOnOrder?: number | null } | null }> }> } } | null };

export type GetOrderTrackerQueryVariables = Exact<{
  orderNo: Scalars['String']['input'];
}>;


export type GetOrderTrackerQuery = { __typename?: 'Query', getOrderTracker?: { __typename?: 'OrderTracker', orderNo: string, registered: string, lastUpdates: { __typename?: 'LastUpdate', order?: { __typename?: 'Order', timestamp: string, orderNo: string, company: string, customerId: string, shipViaCode: string, customerPoNo?: string | null, marking?: string | null, state?: string | null, cfCMarking?: string | null, contacts?: Array<{ __typename?: 'Contact', contactType?: string | null, email?: string | null, firstName?: string | null, id?: string | null, lastName?: string | null, name?: string | null, phone?: string | null } | null> | null, orderLines?: Array<{ __typename?: 'OrderLine', plannedDeliveryDate?: string | null, lineNo?: string | null, relNo?: string | null, qtyOrdered?: string | null, qtyDelivered?: number | null, description?: string | null, salesUom?: string | null, dataSheet?: string | null, safetySheet?: string | null, inventoryPart?: boolean | null, state?: string | null } | null> | null } | null, feedbacks: Array<{ __typename?: 'Feedback', score: number, text: string, meta?: { __typename?: 'FeedbackMeta', ref?: string | null } | null }>, trips: Array<{ __typename?: 'Consolidation', id: string, timestamp: string, completed: string, plannedDeliveryDate: string, plannedArrivalTime: string, shipmentId: string, orderNo: string, driveTo: string }>, fulfilledShipments: Array<{ __typename?: 'FulfilledShipment', shipmentId: number, timestamp: string }>, completedShipments: Array<{ __typename?: 'CompletedShipment', shipmentId: number, timestamp: string }>, shipments: Array<{ __typename?: 'Shipment', shipmentLines: Array<{ __typename?: 'ShipmentLine', qtyPicked?: number | null, qtyShipped?: number | null, orderSource?: { __typename?: 'SourceOrder', lineNo?: number | null, relNo?: string | null, qtyOnOrder?: number | null } | null }>, shipmentHead: { __typename?: 'ShipmentHead', shipmentId: number, timestamp: string, status: string, routeId: string, shipVia: string, receiverId: string, pickupLocation?: { __typename?: 'Location', address1: string, address2?: string | null, city: string, name: string, zipCode: string } | null } }> }, logs: Array<{ __typename?: 'Log', createdAt: string, text: string, type: string, source: string }> } | null };

export type GetShipmentSummaryLegacyQueryVariables = Exact<{
  orderNo: Scalars['String']['input'];
}>;


export type GetShipmentSummaryLegacyQuery = { __typename?: 'Query', getShipmentSummary?: { __typename?: 'ShipmentSummary', orderNo: string, registered: string, customerId: string, cfCMarking?: string | null, customerPoNo?: string | null, unPlannedLines: Array<{ __typename?: 'Line', article: string, ordered: string, inventoryPart?: boolean | null }>, shipments: Array<{ __typename?: 'ShipmentInfo', id: string, shipViaCode: string, status?: string | null, images: Array<string | null>, lines: Array<{ __typename?: 'Line', article: string, ordered: string, datasheet: string, safetysheet: string, inventoryPart?: boolean | null }>, pickup?: { __typename?: 'Pickup', registeredDatetime: string, fulfilledDateTime?: string | null, deliveredDateTime?: string | null, zipCode?: string | null, name?: string | null, address?: string | null } | null, delivery?: { __typename?: 'Delivery', registeredDatetime: string, routeId: string, company: string, plannedDatetime?: string | null, enRouteDatetime?: string | null, deliveredDateTime?: string | null } | null, feedback?: { __typename?: 'Feedback', score: number, text: string } | null }> } | null };

export type GetShipmentSummaryQueryVariables = Exact<{
  hash: Scalars['String']['input'];
}>;


export type GetShipmentSummaryQuery = { __typename?: 'Query', getShipmentSummaryFromHash?: { __typename?: 'ShipmentSummary', phone: string, orderNo: string, registered: string, customerId: string, marking: string, cfCMarking?: string | null, unPlannedLines: Array<{ __typename?: 'Line', article: string, ordered: string, inventoryPart?: boolean | null }>, shipments: Array<{ __typename?: 'ShipmentInfo', id: string, shipViaCode: string, images: Array<string | null>, status?: string | null, lines: Array<{ __typename?: 'Line', article: string, ordered: string, datasheet: string, safetysheet: string, inventoryPart?: boolean | null, delivered: string }>, pickup?: { __typename?: 'Pickup', registeredDatetime: string, fulfilledDateTime?: string | null, deliveredDateTime?: string | null, zipCode?: string | null, name?: string | null, address?: string | null, address1?: { __typename?: 'PickupAddress', city: string, zip: string, street: string } | null } | null, delivery?: { __typename?: 'Delivery', registeredDatetime: string, routeId: string, company: string, plannedDatetime?: string | null, enRouteDatetime?: string | null, deliveredDateTime?: string | null } | null, feedback?: { __typename?: 'Feedback', score: number, text: string } | null }> } | null };

export type SetCustomerContactSettingMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
  setting: Scalars['Int']['input'];
}>;


export type SetCustomerContactSettingMutation = { __typename?: 'Mutation', setCustomerContactSetting: { __typename?: 'CustomerContactSetting', setting: number } };

export type SetFeedbackMutationVariables = Exact<{
  orderNo: Scalars['String']['input'];
  score: Scalars['Int']['input'];
  text: Scalars['String']['input'];
  ref: Scalars['String']['input'];
}>;


export type SetFeedbackMutation = { __typename?: 'Mutation', setFeedback?: { __typename?: 'Feedback', score: number, text: string, meta?: { __typename?: 'FeedbackMeta', ref?: string | null } | null } | null };


export const GetCustomerContactSettingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCustomerContactSetting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCustomerContactSetting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setting"}}]}}]}}]} as unknown as DocumentNode<GetCustomerContactSettingQuery, GetCustomerContactSettingQueryVariables>;
export const GetTrackerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTracker"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderNo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrderTracker"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderNo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderNo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderNo"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"orderNo"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"marking"}},{"kind":"Field","name":{"kind":"Name","value":"cfCMarking"}},{"kind":"Field","name":{"kind":"Name","value":"orderLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"relNo"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"salesUom"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"contactType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipmentHead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipVia"}},{"kind":"Field","name":{"kind":"Name","value":"shipmentId"}},{"kind":"Field","name":{"kind":"Name","value":"pickupLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipmentLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relNo"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"qtyOnOrder"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qtyPicked"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTrackerQuery, GetTrackerQueryVariables>;
export const GetOrderTrackerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderTracker"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderNo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrderTracker"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderNo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderNo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderNo"}},{"kind":"Field","name":{"kind":"Name","value":"registered"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"orderNo"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"shipViaCode"}},{"kind":"Field","name":{"kind":"Name","value":"customerPoNo"}},{"kind":"Field","name":{"kind":"Name","value":"marking"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"cfCMarking"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactType"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plannedDeliveryDate"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"relNo"}},{"kind":"Field","name":{"kind":"Name","value":"qtyOrdered"}},{"kind":"Field","name":{"kind":"Name","value":"qtyDelivered"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"salesUom"}},{"kind":"Field","name":{"kind":"Name","value":"dataSheet"}},{"kind":"Field","name":{"kind":"Name","value":"safetySheet"}},{"kind":"Field","name":{"kind":"Name","value":"inventoryPart"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feedbacks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trips"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"plannedDeliveryDate"}},{"kind":"Field","name":{"kind":"Name","value":"plannedArrivalTime"}},{"kind":"Field","name":{"kind":"Name","value":"shipmentId"}},{"kind":"Field","name":{"kind":"Name","value":"orderNo"}},{"kind":"Field","name":{"kind":"Name","value":"driveTo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fulfilledShipments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipmentId"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedShipments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipmentId"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipmentLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qtyPicked"}},{"kind":"Field","name":{"kind":"Name","value":"qtyShipped"}},{"kind":"Field","name":{"kind":"Name","value":"orderSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"relNo"}},{"kind":"Field","name":{"kind":"Name","value":"qtyOnOrder"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipmentHead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipmentId"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"routeId"}},{"kind":"Field","name":{"kind":"Name","value":"shipVia"}},{"kind":"Field","name":{"kind":"Name","value":"receiverId"}},{"kind":"Field","name":{"kind":"Name","value":"pickupLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"logs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrderTrackerQuery, GetOrderTrackerQueryVariables>;
export const GetShipmentSummaryLegacyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetShipmentSummaryLegacy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderNo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getShipmentSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderNo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderNo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderNo"}},{"kind":"Field","name":{"kind":"Name","value":"registered"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"cfCMarking"}},{"kind":"Field","name":{"kind":"Name","value":"customerPoNo"}},{"kind":"Field","name":{"kind":"Name","value":"unPlannedLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article"}},{"kind":"Field","name":{"kind":"Name","value":"ordered"}},{"kind":"Field","name":{"kind":"Name","value":"inventoryPart"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shipViaCode"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article"}},{"kind":"Field","name":{"kind":"Name","value":"ordered"}},{"kind":"Field","name":{"kind":"Name","value":"datasheet"}},{"kind":"Field","name":{"kind":"Name","value":"safetysheet"}},{"kind":"Field","name":{"kind":"Name","value":"inventoryPart"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pickup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registeredDatetime"}},{"kind":"Field","name":{"kind":"Name","value":"fulfilledDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"deliveredDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registeredDatetime"}},{"kind":"Field","name":{"kind":"Name","value":"routeId"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"plannedDatetime"}},{"kind":"Field","name":{"kind":"Name","value":"enRouteDatetime"}},{"kind":"Field","name":{"kind":"Name","value":"deliveredDateTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetShipmentSummaryLegacyQuery, GetShipmentSummaryLegacyQueryVariables>;
export const GetShipmentSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetShipmentSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hash"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getShipmentSummaryFromHash"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hash"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hash"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"orderNo"}},{"kind":"Field","name":{"kind":"Name","value":"registered"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"marking"}},{"kind":"Field","name":{"kind":"Name","value":"cfCMarking"}},{"kind":"Field","name":{"kind":"Name","value":"unPlannedLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article"}},{"kind":"Field","name":{"kind":"Name","value":"ordered"}},{"kind":"Field","name":{"kind":"Name","value":"inventoryPart"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shipViaCode"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article"}},{"kind":"Field","name":{"kind":"Name","value":"ordered"}},{"kind":"Field","name":{"kind":"Name","value":"datasheet"}},{"kind":"Field","name":{"kind":"Name","value":"safetysheet"}},{"kind":"Field","name":{"kind":"Name","value":"inventoryPart"}},{"kind":"Field","name":{"kind":"Name","value":"delivered"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pickup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registeredDatetime"}},{"kind":"Field","name":{"kind":"Name","value":"fulfilledDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"deliveredDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"address1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"street"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registeredDatetime"}},{"kind":"Field","name":{"kind":"Name","value":"routeId"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"plannedDatetime"}},{"kind":"Field","name":{"kind":"Name","value":"enRouteDatetime"}},{"kind":"Field","name":{"kind":"Name","value":"deliveredDateTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetShipmentSummaryQuery, GetShipmentSummaryQueryVariables>;
export const SetCustomerContactSettingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetCustomerContactSetting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"setting"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setCustomerContactSetting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"setting"},"value":{"kind":"Variable","name":{"kind":"Name","value":"setting"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setting"}}]}}]}}]} as unknown as DocumentNode<SetCustomerContactSettingMutation, SetCustomerContactSettingMutationVariables>;
export const SetFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderNo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"score"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ref"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderNo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderNo"}}},{"kind":"Argument","name":{"kind":"Name","value":"score"},"value":{"kind":"Variable","name":{"kind":"Name","value":"score"}}},{"kind":"Argument","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}},{"kind":"Argument","name":{"kind":"Name","value":"ref"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ref"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}}]}}]} as unknown as DocumentNode<SetFeedbackMutation, SetFeedbackMutationVariables>;